import React from 'react'

import { css } from 'design'
import { Button, ButtonProps } from 'primitives/button'
import { cn } from 'util/cn'

export const sidebarButtonStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '56px',
  fontSize: '$1',
  padding: '0 !important',

  i: {
    fontSize: '$3',
    lineHeight: 1.5,
    height: '26px',

    '&.topic__sidebarbutton__labelicon': {
      fontSize: 'inherit',
      height: 'auto',
      lineHeight: 'inherit',
    },
  },

  '> *': {
    color: 'inherit',
    fill: 'inherit',
  },
})

export const SidebarButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Button
        className={cn(
          'topic__sidebarbutton',
          sidebarButtonStyles(),
          className,
        )}
        {...props}
        ref={ref}
      >
        {children}
      </Button>
    )
  },
)

SidebarButton.displayName = 'SidebarButton'
